"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customers = void 0;
exports.customers = {
    DEFAULT: {
        development: {
            lang: 'es',
            title: 'Robots - EDUCABOT',
            titleAnimations: 'Animaciones - EDUCABOT',
            theme: 'root',
            logo: 'logo.png',
            favicon: 'default.svg',
            protocol: 'https://',
            webSocketprotocol: 'wss://',
            aulaProtocol: 'https://',
            builderProtocol: 'https://',
            cosmosFrontUrl: '',
            cosmosFrontAnimationsUrl: '',
            cosmosFrontGamesUrl: '',
            cosmosBackUrl: '',
            baseUrl: '',
            baseLandingUrl: 'http://localhost:9002/landing',
            baseWebSocketUrl: '',
            baseBuilderUrl: 'localhost',
            baseAulaApiUrl: '',
            educablocksPath: 'app',
            educablocksWebSocketPath: 'app',
            bloquesPath: 'bloques',
            animacionesPath: 'animaciones',
            aulaApiPath: 'api',
            notasPath: 'notas',
            diagramasPath: 'diagramas',
            foroPath: 'foro',
            builderPath: 'builder',
            backofficePath: 'backoffice',
            gamePath: 'juegos',
            separator: '-',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            educablocksPort: '',
            foroPort: '',
            bloquesPort: '',
            builderPort: '',
            notasPort: '',
            diagramasPort: '',
            backofficePort: '',
            gamePort: '',
            animacionesPort: '',
            aulaApiPort: '',
            webSocketPort: '',
            facebookID: '1862379324192902',
            googleID: "35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com",
            loginOptions: {
                regular: true,
                facebook: true,
                google: true,
                logo: 'logo_login.png',
                footer: '',
                formText: 'Ingresá correo y contraseña para continuar',
                loginForm: true,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Google',
                    className: '',
                },
                loginFacebookOptions: {
                    display: true,
                }
            },
            boardsOptions: {
                exclude: {
                    prop: '',
                    value: '',
                },
            },
        }
    },
    EDUCABOT: {
        development: {
            lang: 'es',
            title: 'Robots - EDUCABOT',
            titleAnimations: 'Animaciones - EDUCABOT',
            theme: 'root',
            logo: 'logo.png',
            favicon: 'default.svg',
            protocol: 'http://',
            webSocketprotocol: 'ws://',
            aulaProtocol: 'http://',
            builderProtocol: 'http://',
            cosmosFrontUrl: 'localhost',
            cosmosFrontAnimationsUrl: 'localhost',
            cosmosFrontGamesUrl: 'localhost',
            cosmosBackUrl: 'localhost',
            baseUrl: 'localhost',
            baseBuilderUrl: 'localhost',
            baseWebSocketUrl: 'localhost',
            baseAulaApiUrl: 'localhost',
            educablocksPath: '',
            educablocksWebSocketPath: '',
            bloquesPath: '',
            animacionesPath: '',
            aulaApiPath: '',
            notasPath: '',
            diagramasPath: '',
            foroPath: '',
            builderPath: '',
            backofficePath: '',
            gamePath: '',
            separator: '',
            aulaSeparator: '',
            separatorWebSocket: '',
            educablocksPort: ':8084',
            foroPort: ':9001',
            bloquesPort: ':9002',
            builderPort: ':5000',
            notasPort: ':9003',
            diagramasPort: ':9006',
            backofficePort: ':9005',
            gamePort: ':9008',
            animacionesPort: ':8601',
            aulaApiPort: ':5000',
            webSocketPort: ':8084',
        },
        staging: {
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'bloques',
            animacionesPath: 'animaciones',
            educablocksPath: 'app',
            separator: '.',
            aulaApiPath: '',
            aulaSeparator: '',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'bloques.staging.educabot.com',
            cosmosFrontAnimationsUrl: 'animaciones.staging.educabot.com',
            cosmosFrontGamesUrl: 'juegos.staging.educabot.com',
            cosmosBackUrl: 'app.staging.educabot.com',
            baseUrl: 'staging.educabot.com',
            baseLandingUrl: 'https://bloques.staging.educabot.com/landing',
            baseBuilderUrl: 'staging.educabot.com',
            baseWebSocketUrl: 'staging.educabot.com',
            baseAulaApiUrl: 'api-staging-aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
        },
        production: {
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'robots',
            animacionesPath: 'animaciones',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'robots.educabot.com',
            cosmosFrontAnimationsUrl: 'animaciones.educabot.com',
            cosmosFrontGamesUrl: 'juegos.educabot.com',
            cosmosBackUrl: 'app.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://robots.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
        }
    },
    CODIT: {
        development: {
            lang: 'es',
            title: 'Codit',
            titleAnimations: 'Codit',
            favicon: 'default.svg',
            // cosmosFrontUrl: 'rev-robots.educabot.com',
            // cosmosFrontAnimationsUrl: 'rev-animaciones.educabot.com',
            // cosmosBackUrl: 'app.staging.educabot.com',
            baseUrl: 'localhost',
        },
        staging: {
            title: 'Codit',
            titleAnimations: 'Codit',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'codit',
            educablocksPath: 'app',
            separator: '.',
            aulaApiPath: '',
            aulaSeparator: '',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'codit.staging.educabot.com',
            // cosmosFrontAnimationsUrl: 'animaciones.staging.educabot.com',
            cosmosBackUrl: 'app.staging.educabot.com',
            baseUrl: 'staging.educabot.com',
            baseLandingUrl: 'https://bloques.staging.educabot.com/landing',
            baseBuilderUrl: 'staging.educabot.com',
            baseWebSocketUrl: 'staging.educabot.com',
            baseAulaApiUrl: 'api-staging-aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
        },
        production: {
            title: 'Codit',
            titleAnimations: 'Codit',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'codit',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'codit.educabot.com',
            // cosmosFrontAnimationsUrl: 'animaciones.educabot.com',
            cosmosBackUrl: 'app.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://robots.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
        }
    },
    COPA_ROBOTICA: {
        development: {
            title: 'Copa Robótica',
            titleAnimations: 'Copa Robótica',
            theme: 'theme-aula',
            logo: 'logo_caba.svg',
            favicon: 'default.svg',
            cosmosFrontUrl: 'robots.coparobotica.com',
            cosmosFrontAnimationsUrl: 'animaciones.coparobotica.com',
            cosmosBackUrl: 'app.coparobotica.com',
            baseUrl: 'coparobotica.com',
        },
        staging: {
            title: 'Copa Robótica',
            titleAnimations: 'Copa Robótica',
            theme: 'theme-aula',
            logo: 'logo_caba.svg',
            favicon: 'default.svg',
            protocol: 'https://',
            aulaProtocol: 'http://',
            bloquesPath: 'robots',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'robots.coparobotica.com',
            cosmosFrontAnimationsUrl: 'animaciones.coparobotica.com',
            cosmosBackUrl: 'app.coparobotica.com',
            baseUrl: 'coparobotica.com',
            baseLandingUrl: 'https://robots.coparobotica.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'coparobotica.com',
            baseAulaApiUrl: 'api-staging-aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
        }
    },
    CREATEC: {
        development: {
            title: 'CREATEC',
            titleAnimations: 'CREATEC',
            theme: 'theme-aula',
            logo: 'logo_caba.svg',
            favicon: 'caba.png',
            cosmosFrontUrl: 'robots.createc.bue.edu.ar',
            cosmosFrontAnimationsUrl: 'animaciones.createc.bue.edu.ar',
            cosmosBackUrl: 'app.createc.bue.edu.ar',
            baseUrl: 'createc.bue.edu.ar',
            baseLandingUrl: '',
            loginOptions: {
                regular: false,
                facebook: false,
                google: true,
                logo: 'logo_createc.svg',
                footer: 'footerCreatec.svg',
                formText: 'Por favor, ingresa con tu cuenta Google BA:',
                loginForm: false,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Ingresar con Google',
                    className: 'google-login',
                },
                loginFacebookOptions: {
                    display: false,
                }
            },
            boardsOptions: {
                exclude: {
                    prop: 'company',
                    value: 'Smart Team',
                },
            }
        },
        staging: {
            title: 'CREATEC',
            titleAnimations: 'CREATEC',
            theme: 'theme-aula',
            logo: 'logo_caba.svg',
            favicon: 'caba.png',
            protocol: 'https://',
            aulaProtocol: 'http://',
            bloquesPath: 'robots',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'robots.createc.bue.edu.ar',
            cosmosFrontAnimationsUrl: 'animaciones.createc.bue.edu.ar',
            cosmosBackUrl: 'app.createc.bue.edu.ar',
            baseUrl: 'createc.bue.edu.ar',
            baseLandingUrl: 'https://createc.bue.edu.ar',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'createc.bue.edu.ar',
            baseAulaApiUrl: 'api-staging-aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '2527628780848865',
            loginOptions: {
                regular: false,
                facebook: false,
                google: true,
                logo: 'logo_createc.svg',
                footer: 'footerCreatec.svg',
                formText: 'Por favor, ingresa con tu cuenta Google BA:',
                loginForm: false,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Ingresar con Google',
                    className: 'google-login',
                },
                loginFacebookOptions: {
                    display: false,
                }
            },
            boardsOptions: {
                exclude: {
                    prop: 'company',
                    value: 'Smart Team',
                },
            }
        },
        production: {
            title: 'CREATEC',
            titleAnimations: 'CREATEC',
            theme: 'theme-aula',
            logo: 'logo_caba.svg',
            favicon: 'caba.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'robots',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'robots.createc.bue.edu.ar',
            cosmosFrontAnimationsUrl: 'animaciones.createc.bue.edu.ar',
            cosmosBackUrl: 'app.createc.bue.edu.ar',
            baseUrl: 'createc.bue.edu.ar',
            baseLandingUrl: 'https://createc.bue.edu.ar',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'createc.bue.edu.ar',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '117860338625786',
            loginOptions: {
                regular: false,
                facebook: false,
                google: true,
                logo: 'logo_createc.svg',
                footer: 'footerCreatec.svg',
                formText: 'Por favor, ingresa con tu cuenta Google BA:',
                loginForm: false,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Ingresar con Google',
                    className: 'google-login',
                },
                loginFacebookOptions: {
                    display: false,
                }
            },
            boardsOptions: {
                exclude: {
                    prop: 'company',
                    value: 'Smart Team',
                },
            }
        }
    },
    REV_ROBOTICS: {
        development: {
            lang: 'en',
            title: 'Rev Robotics',
            titleAnimations: 'Rev Robotics',
            // theme: 'theme-aula',
            // logo: 'logo_caba.svg',
            favicon: 'default.svg',
            cosmosFrontUrl: 'rev-robots.educabot.com',
            cosmosFrontAnimationsUrl: 'rev-animaciones.educabot.com',
            cosmosBackUrl: 'rev-app.educabot.com',
            baseUrl: 'localhost',
        },
        production: {
            lang: 'en',
            title: 'Rev Robotics',
            titleAnimations: 'Rev Robotics',
            theme: 'theme-rev',
            logo: 'rev-robotics.svg',
            favicon: 'default.svg',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'rev-robots',
            educablocksPath: 'rev-app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'rev-robots.educabot.com',
            cosmosFrontAnimationsUrl: 'rev-animaciones.educabot.com',
            cosmosBackUrl: 'rev-app.educabot.com',
            baseUrl: 'educabot.com',
            animacionesPath: 'rev-animaciones',
            baseLandingUrl: 'https://robots.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
        }
    },
    FIFA: {
        development: {
            lang: 'en',
            title: 'FIFA Foundation',
            titleAnimations: 'FIFA Foundation',
            theme: 'theme-fifa',
            logo: 'logo_fifa.svg',
            favicon: 'fifa.png',
            cosmosFrontUrl: 'robots.fifa.com.ar',
            cosmosFrontAnimationsUrl: 'animaciones.fifa.com.ar',
            cosmosBackUrl: 'localhost',
            baseUrl: 'localhost',
            baseLandingUrl: '',
            loginOptions: {
                regular: true,
                facebook: true,
                google: true,
                logo: 'logo_fifa.svg',
                footer: '',
                formTitle: 'Login to Robots',
                formText: 'Enter email and password to continue',
                formUser: 'e-Mail',
                formPassword: 'Password',
                formForgot: 'Did you forget your password?',
                formEnter: 'Enter',
                formContinue: 'Or continue with',
                formNotAccount: 'don\'t have an account?',
                formCreateAccount: 'Create user account',
                formError: 'There was a problem with the entry. Please try another time.',
                formDisclaimer: 'By cicking "Continue with Google/Facebook" you accept our <a href="https://educabot.com/nosotros/">Terms and Conditions</a> and our <a href="https://educabot.com/nosotros/">Privacy Policy</a>',
                loginForm: true,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Google',
                    className: '',
                },
                loginFacebookOptions: {
                    display: true,
                }
            }
        },
        staging: {
            lang: 'en',
            title: 'FIFA Foundation',
            titleAnimations: 'FIFA Foundation',
            theme: 'theme-fifa',
            logo: 'logo_fifa.svg',
            favicon: 'fifa.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'staging.robots.fifa',
            educablocksPath: 'app.staging',
            builderPath: 'builder.staging',
            educablocksWebSocketPath: 'app.staging',
            animacionesPath: 'staging.animations.fifa',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'staging.robots.fifa.educabot.com',
            cosmosFrontAnimationsUrl: 'staging.animations.fifa.educabot.com',
            cosmosBackUrl: 'app.staging.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://staging.robots.fifa.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'api-staging-aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
            loginOptions: {
                regular: true,
                facebook: true,
                google: true,
                logo: 'logo_fifa.svg',
                footer: '',
                formTitle: 'Login to Robots',
                formText: 'Enter email and password to continue',
                formUser: 'e-Mail',
                formPassword: 'Password',
                formForgot: 'Did you forget your password?',
                formEnter: 'Enter',
                formContinue: 'Or continue with',
                formNotAccount: 'don\'t have an account?',
                formCreateAccount: 'Create user account',
                formError: 'There was a problem with the entry. Please try another time.',
                formDisclaimer: 'By cicking "Continue with Google/Facebook" you accept our <a href="https://educabot.com/nosotros/">Terms and Conditions</a> and our <a href="https://educabot.com/nosotros/">Privacy Policy</a>',
                loginForm: true,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Google',
                    className: '',
                },
                loginFacebookOptions: {
                    display: true,
                }
            }
        },
        production: {
            lang: 'en',
            title: 'FIFA Foundation',
            titleAnimations: 'FIFA Foundation',
            theme: 'theme-fifa',
            logo: 'logo_fifa.svg',
            favicon: 'fifa.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'robots',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'robots.fifa.educabot.com',
            cosmosFrontAnimationsUrl: 'animations.fifa.educabot.com',
            cosmosBackUrl: 'app.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://robots.fifa.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
            loginOptions: {
                regular: true,
                facebook: true,
                google: true,
                logo: 'logo_fifa.svg',
                footer: '',
                formTitle: 'Login to Robots',
                formText: 'Enter email and password to continue',
                formUser: 'e-Mail',
                formPassword: 'Password',
                formForgot: 'Did you forget your password?',
                formEnter: 'Enter',
                formContinue: 'Or continue with',
                formNotAccount: 'don\'t have an account?',
                formCreateAccount: 'Create user account',
                formError: 'There was a problem with the entry. Please try another time.',
                formDisclaimer: 'By cicking "Continue with Google/Facebook" you accept our <a href="https://educabot.com/nosotros/">Terms and Conditions</a> and our <a href="https://educabot.com/nosotros/">Privacy Policy</a>',
                loginForm: true,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Google',
                    className: '',
                },
                loginFacebookOptions: {
                    display: true,
                }
            }
        }
    },
    FIFA_FOUNDATION: {
        production: {
            lang: 'en',
            title: 'FIFA Foundation',
            titleAnimations: 'FIFA Foundation',
            theme: 'theme-fifa',
            logo: 'logo_fifa.svg',
            favicon: 'fifa.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'maker',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'maker.fifafoundation.org',
            cosmosFrontAnimationsUrl: 'animations.fifafoundation.org',
            cosmosBackUrl: 'app.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://maker.fifafoundation.org/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902',
            loginOptions: {
                regular: true,
                facebook: true,
                google: true,
                logo: 'logo_fifa.svg',
                footer: '',
                formTitle: 'Login to FIFA Foundation',
                formText: 'Enter email and password to continue',
                formUser: 'e-Mail',
                formPassword: 'Password',
                formForgot: 'Did you forget your password?',
                formEnter: 'Enter',
                formContinue: 'Or continue with',
                formNotAccount: 'don\'t have an account?',
                formCreateAccount: 'Create user account',
                formError: 'There was a problem with the entry. Please try another time.',
                formDisclaimer: 'By cicking "Continue with Google/Facebook" you accept our <a href="https://educabot.com/nosotros/">Terms and Conditions</a> and our <a href="https://educabot.com/nosotros/">Privacy Policy</a>',
                loginForm: true,
                loginGoogleOptions: {
                    display: true,
                    icon: 'google.svg',
                    text: 'Google',
                    className: '',
                },
                loginFacebookOptions: {
                    display: true,
                }
            }
        }
    },
    CREABOTS: {
        development: {
            lang: 'es',
            title: 'CREABOTS',
            titleAnimations: 'CREABOTS',
            theme: 'theme-labs',
            logo: 'logo_labs.svg',
            favicon: 'labs.png',
            cosmosFrontUrl: 'labs.educabot.com',
            cosmosFrontAnimationsUrl: 'animaciones.labs.educabot.com',
            cosmosBackUrl: 'localhost',
            baseUrl: 'localhost',
            baseLandingUrl: ''
        },
        staging: {
            lang: 'es',
            title: 'CREABOTS',
            titleAnimations: 'CREABOTS',
            theme: 'theme-labs',
            logo: 'logo_labs.svg',
            favicon: 'labs.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'labs.staging',
            educablocksPath: 'app.staging',
            builderPath: 'builder.staging',
            educablocksWebSocketPath: 'app.staging',
            animacionesPath: 'animations.labs.staging',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'labs.staging.educabot.com',
            cosmosFrontAnimationsUrl: 'animations.labs.staging.educabot.com',
            cosmosBackUrl: 'app.staging.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://labs.staging.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'api-staging-aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902'
        },
        production: {
            lang: 'es',
            title: 'CREABOTS',
            titleAnimations: 'CREABOTS',
            theme: 'theme-labs',
            logo: 'logo_labs.svg',
            favicon: 'labs.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'labs',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'labs.educabot.com',
            cosmosFrontAnimationsUrl: 'animations.labs.educabot.com',
            cosmosBackUrl: 'app.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://labs.educabot.com/landing',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902'
        }
    },
    CREABOTS_LANDING: {
        production: {
            lang: 'es',
            title: 'CREABOTS',
            titleAnimations: 'CREABOTS',
            theme: 'theme-labs',
            logo: 'logo_labs.svg',
            favicon: 'labs.png',
            protocol: 'https://',
            aulaProtocol: 'https://',
            bloquesPath: 'creabots',
            educablocksPath: 'app',
            separator: '.',
            aulaSeparator: '.',
            separatorWebSocket: '.',
            cosmosFrontUrl: 'creabots.educabot.com',
            cosmosFrontAnimationsUrl: 'animations.labs.educabot.com',
            cosmosBackUrl: 'app.educabot.com',
            baseUrl: 'educabot.com',
            baseLandingUrl: 'https://creabots.educabot.com/kits',
            baseBuilderUrl: 'educabot.com',
            baseWebSocketUrl: 'educabot.com',
            baseAulaApiUrl: 'aula.educabot.com',
            googleID: '35003362827-qjctsvcccj7s8cicjjl3otk000vkcqkn.apps.googleusercontent.com',
            facebookID: '1862379324192902'
        }
    },
};
//# sourceMappingURL=customers.js.map